import { useKconfStore } from '@/store/useKconfStore';

/**
 * 合并所有kconf请求
 * @deprecated 将kconf信息放到单例的store中了，使用 useKconfStore 代替，大家可以使用selector来减少ab导致的render
 */
export function useFirstScreenKconf() {
    const state = useKconfStore();
    return state;
}
